export default function (filtro) {
  this.TipoMessaggio = filtro ? filtro.TipoMessaggio : null;
  this.Stato = filtro ? filtro.Stato : '0';
}
